import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatRadioChange } from '@angular/material/radio';

import { ICustomer } from '@ruby/modules/customer-select/models/customer.interface';
import { IThirdPartyLineOfBusiness, IThirdPartySearchCompany } from '@ruby/modules/third-party/models/third-party.interface';
import { ERole } from '@ruby/shared/enums/roles.enums';
import { UtilsService } from '@ruby/shared/services/utils/utils.service';

@Component({
  selector: 'ng-third-party-done',
  templateUrl: './third-party-done.component.html',
  styleUrls: ['./third-party-done.component.scss']
})
export class ThirdPartyDoneComponent {
  @Input() customerCompany?: ICustomer;
  @Input() providerCompany?: IThirdPartySearchCompany;
  @Input() lineOfBusiness!: Array<IThirdPartyLineOfBusiness>;
  @Input() selectedLOB?: string;
  @Output() accept = new EventEmitter();
  @Output() cancel = new EventEmitter();
  @Output() selectedLob = new EventEmitter<ERole>();

  constructor(private utilSvc: UtilsService) { }

  /**
   * Emit Cancel
   *
   * @summary This function emits an event to cancel the sign of MultiPersona contract
   * @returns void
   */
  emitCancel(): void {
    this.cancel.emit();
  }

  /**
   * Emit Action
   *
   * @summary This function emits an event to complete another LOA with different Line Of Business or go back to main page
   * @returns void
   */
  emitAction(): void {
    this.lineOfBusiness.length > 0 ? this.accept.emit() : this.cancel.emit();
  }

  /**
   * Select LOB
   *
   * @summary This function select the line of business
   * @param $event: MatRadioChange
   * @returns void
   */
  selectLob($event: MatRadioChange): void {
    this.selectedLob.emit($event.value);
  }

  /**
   * Description
   *
   * @summary This function gets the human read description
   * @param role: ERole
   * @returns string
   */
  description(role: ERole): string {
    return this.utilSvc.mappingRoleToTitle(role);
  }

  /**
   * Description From LOB
   *
   * @summary This function gets the human read description from LOB
   * @param lob?: string
   * @returns string
   */
  descriptionFromLob(lob?: string): string {
    return lob ? this.utilSvc.capitalize(lob) : '';
  }
}
